import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/base/services';
import { rutFormat, RutValidator } from 'ng9-rut';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
    form: any = this.fb.group({
        rut: ['', [Validators.required, this.rutValidator]],
        password: ['', Validators.required],
    });
    loading = false;
    showError = false;
    constructor(
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private rutValidator: RutValidator
    ) {
        if (this.authenticationService.usuarioLogueadoData) {
            this.router.navigate(['/']);
        }
    }

    get rut() {
        return this.form.get('rut');
    }

    get password() {
        return this.form.get('password');
    }

    ngOnInit(): void {}

    login() {
        if (this.form.invalid) return;
        this.loading = true;
        this.authenticationService.login(this.rut.value, this.password.value);
        this.authenticationService.usuarioLogueado.subscribe({
            next: () => {
                const returnUrl =
                    this.route.snapshot.queryParams['returnUrl'] || '/';
                this.router.navigate([returnUrl]);
            },
        });
        this.authenticationService.errorLogin.subscribe({
            next: () => {
                this.showError = true;
                this.loading = false;
            },
        });
    }

    formatearRut() {
        this.rut.setValue(rutFormat(this.rut.value));
        this.showError = false;
    }
}
